// generated by the plop

import { PaginateQuery } from 'symbols';

export class GetCodeStatusList {
  static type = '[codeStatus] GetCodeStatusList';

  constructor(public filter: PaginateQuery<{ search: string }>) {

  }
}
